import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EstacaoGrupoService } from 'src/services/estacao-grupos.service';
import { EstacaoService } from 'src/services/estacao.service';
import { PermissoesService } from 'src/services/permissoes.service';

@Component({
    selector: 'app-grupo-estacao',
    templateUrl: './grupo-estacao.component.html',
    styleUrls: ['./grupo-estacao.component.scss'],
    standalone: false
})
export class GrupoEstacaoComponent implements OnInit, AfterViewInit {
  array_estacoes: any[] = []
  dropDownEstacoes: any[] = []
  data: any[] = []
  displayModal: boolean = false
  loading: boolean = false
  form: FormGroup;
  direitoInserir: boolean = false;
  direitoEditar: boolean = false;
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '600px'; // Valor inicial maior para garantir renderização

  constructor(
    protected _estacaoService: EstacaoService,
    protected _formBuilder: FormBuilder,
    protected permissaoService: PermissoesService,
    protected estacaoGrupoService: EstacaoGrupoService,
  ) { }

  ngOnInit(): void {
    this.direitoInserir = this.permissaoService.can('grupo_estacao_inserir');
    this.direitoEditar = this.permissaoService.can('grupo_estacao_editar');

    this.form = this._formBuilder.group({
      id: [null],
      nome: [null],
      ativo: [null],
    })
    this.listEstacoes()
    this.index()
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      // Subtrai apenas altura do caption (~60px) e paginator (~60px), header já está dentro do scrollable
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    } else {
      // Se o wrapper ainda não estiver disponível, tenta novamente
      setTimeout(() => {
        this.calculateScrollHeight();
      }, 100);
    }
  }

  index(){
    this.estacaoGrupoService.index().subscribe(json => {
      console.log('Dados recebidos:', json);
      this.data = json || [];
      console.log('Data após atribuição:', this.data);
      setTimeout(() => {
        this.calculateScrollHeight();
      }, 200);
    }, error => {
      console.error('Erro ao carregar grupos de estação:', error);
      this.data = [];
    })
  }

  listEstacoes(): void {
    this._estacaoService.lookup().subscribe(json => {
      this.dropDownEstacoes = [
        { value: 'null', label: 'Selecione' },
        ...json.map(item => ({
          value: item.id,
          label: item.descricao
        }))
      ];
    });
  }

  edit(event){
    this.array_estacoes = []
    this.form.reset()
    this.estacaoGrupoService.show(event.id).subscribe(json =>{
      this.form.patchValue(json)
      if(json.estacoes){
        json.estacoes.map(item => {
          this.array_estacoes.push({
            estacao_id: item.id
          })
        })
      }
      this.displayModal = true
    })

  }
  
  openNew(){
    this.array_estacoes = []
    this.form.reset()
    this.form.get('ativo').setValue(true)
this.displayModal = true

  }

  addEstacao(){
    this.array_estacoes.push({
      estacao_id: null
    })
  }

  removeEstacao(event) {
    this.array_estacoes = this.array_estacoes.filter(x => { return x !== event });
  }

  save(){
    let form = this.form.value
    let params = form
params.estacaoList = this.array_estacoes
this.estacaoGrupoService.save(params, form.id).subscribe(json => {
  this.index()
  this.displayModal = false
}, err => {

})
  }
}
